// removed by extract-text-webpack-plugin
module.exports = {"messageList":"_2etHO","hasAside":"_33THj","hasMoreMessages":"_3KVPj","prompts":"_1VyRw","prompt":"_1fGt6","slideInBottom":"PCXeK","next":"_25Ymf","icon":"_2nxJC","facebook":"_3ozwA","twitter":"_2mHbm","bottomSensor":"_3YODH"};


/*****************
 ** WEBPACK FOOTER
 ** ./components/MessageList/styles.css
 ** module id = 342
 ** module chunks = 0
 **/